import { useTranslation } from 'react-i18next';
import { CellType, ICell } from '../../../../base';

export const useTableCells = (): ICell[] => {
    const { t } = useTranslation();

    const cells: Array<ICell> = [
        {
            id: 'id',
            headerTitle: t('jobsTable.pargodaId'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'id' },
            isSortable: true,
        },
        {
            id: 'external_job_id',
            headerTitle: t('jobsTable.externalId'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'externalJobId' },
            isSortable: true,
        },
        {
            id: 'title',
            headerTitle: t('jobsTable.positionTitle'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'title' },
            isSortable: true,
        },
        {
            id: 'published_date',
            headerTitle: t('jobsTable.publishedDate'),
            type: CellType.DateAndTime,
            cellFields: { text: 'publishedDate' },
            isSortable: true,
        },
        {
            id: 'status',
            headerTitle: t('jobsTable.status'),
            type: CellType.Label,
            cellFields: { labelText: 'statusLabel', labelColor: 'statusColor' },
        },
        {
            id: 'recruiter',
            headerTitle: t('jobsTable.recruiter'),
            type: CellType.Person,
            cellFields: { name: 'recruiterName', icon: 'recruiterIcon' },
            isSortable: true,
        },
        {
            id: 'tags',
            headerTitle: t('jobsTable.tags'),
            type: CellType.Tags,
            cellFields: {
                objectId: 'id',
                modelName: 'modelName',
                appliedTags: 'appliedTags',
                disabled: 'isLegacy',
            },
            isSortable: false,
        },
        {
            id: 'recruiting_manager',
            headerTitle: t('jobsTable.recruitingManager'),
            type: CellType.Person,
            cellFields: {
                name: 'recruitingManagerName',
                icon: 'recruitingManagerIcon',
            },
            isSortable: true,
        },
        {
            id: 'actionMenu',
            headerTitle: '',
            type: CellType.Menu,
            cellFields: { menuActions: 'menuActions' },
        },
    ];
    cells.forEach((cell, index) => {
        cell.columnIndex = index;
    });

    return cells;
};
